import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-162d4265")

_pushScopeId("data-v-162d4265")
const _hoisted_1 = {
  key: 0,
  class: "terms-form"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("p", { class: "terms-title" }, "ご利用規約の同意", -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("p", { class: "tip" }, " 利用規約に同意の上、パスワード登録画面にお進みください。 ", -1)
const _hoisted_4 = { class: "terms-buttons" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 同意しない")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 同意する")
const _hoisted_7 = {
  key: 1,
  class: "set-password-form"
}
const _hoisted_8 = /*#__PURE__*/_createVNode("p", { class: "tip" }, " パスワードを設定してください。（ 12～32文字 ／英文字、数字、記号※各1種類） ※ - _. * ! # $ % & + / = ? ^ ` { | } ~ ", -1)
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" 戻る")
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" 設定")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_logo = _resolveComponent("logo")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_form = _resolveComponent("el-form")
  const _component_wrapper = _resolveComponent("wrapper")

  return (_ctx.isValid)
    ? (_openBlock(), _createBlock(_component_wrapper, {
        key: 0,
        class: "wrapper"
      }, {
        default: _withId(() => [
          (_ctx.showTerms)
            ? (_openBlock(), _createBlock("div", _hoisted_1, [
                _createVNode(_component_logo, { class: "logo-pic" }),
                _hoisted_2,
                _hoisted_3,
                _createVNode(_component_el_input, {
                  modelValue: _ctx.terms,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.terms = $event)),
                  rows: 18,
                  type: "textarea",
                  readonly: ""
                }, null, 8, ["modelValue"]),
                _createVNode("div", _hoisted_4, [
                  _createVNode(_component_el_button, {
                    type: "info",
                    onClick: _ctx.handleNoAccept,
                    class: "terms-button"
                  }, {
                    default: _withId(() => [
                      _hoisted_5
                    ]),
                    _: 1
                  }, 8, ["onClick"]),
                  _createVNode(_component_el_button, {
                    type: "primary",
                    onClick: _ctx.handleAccept,
                    class: "terms-button"
                  }, {
                    default: _withId(() => [
                      _hoisted_6
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ])
              ]))
            : (_openBlock(), _createBlock("div", _hoisted_7, [
                _createVNode(_component_logo, { class: "logo-pic" }),
                _hoisted_8,
                _createVNode(_component_el_form, {
                  model: _ctx.ruleForm,
                  rules: _ctx.rules,
                  ref: "passwordForm"
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_form_item, {
                      prop: "password",
                      label: "パスワード"
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_el_input, {
                          type: "password",
                          modelValue: _ctx.ruleForm.password,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.ruleForm.password = $event)),
                          "show-password": ""
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, {
                      prop: "checkPassword",
                      label: "パスワード（確認用）"
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_el_input, {
                          type: "password",
                          modelValue: _ctx.ruleForm.checkPassword,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.ruleForm.checkPassword = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    (_ctx.showTermsFlg)
                      ? (_openBlock(), _createBlock(_component_el_button, {
                          key: 0,
                          type: "info",
                          onClick: _ctx.handleBackToTerms,
                          class: "set-button"
                        }, {
                          default: _withId(() => [
                            _hoisted_9
                          ]),
                          _: 1
                        }, 8, ["onClick"]))
                      : _createCommentVNode("", true),
                    _createVNode(_component_el_button, {
                      type: "primary",
                      loading: _ctx.loading,
                      onClick: _ctx.handleSetPassword,
                      class: "set-button"
                    }, {
                      default: _withId(() => [
                        _hoisted_10
                      ]),
                      _: 1
                    }, 8, ["loading", "onClick"])
                  ]),
                  _: 1
                }, 8, ["model", "rules"])
              ]))
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
})